import React from 'react'
import { Container as ContainerMUI, Stack } from '@mui/material'

const Container = ({ children }) => {
  return (
    <>
      <ContainerMUI>
        <Stack flexDirection="row" justifyContent="center" m={2}>
          {children}
        </Stack>
      </ContainerMUI>
    </>
  )
}

export default Container
